import type { Store, Middleware } from 'redux';

/**
 * Middleware to have one store delegate actions to another.
 *
 * This should then be added into the middleware chain of other
 * stores. Actions with a mapper will not trigger a state update on their
 * origin store, and will instead be lifted into the store this was built
 * against, including any mapping from one action to another.
 *
 * This should be at the 'outer' layer of the middleware chain. (e.g.,
 * wrapping redux-observable).
 */
export const createDelegationMiddleware =
	(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		delegatedStore: Store<any>,
		actionMapper: {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			[key: string]: (arg1?: any) => any;
		},
	): Middleware =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(_store: any) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(next: any) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(action: any) => {
		const mapper = actionMapper[action.type];
		if (mapper) {
			delegatedStore.dispatch(mapper(action));
			return next;
		}
		return next(action);
	};
